module.exports = __webpack_public_path__ + "img/icon18.487f92d5.487f92d5.svg";